import 'whatwg-fetch';
import { fetchGet, fetchPost, fetchDelete, rootApi } from '../helpers/api';

import { getToken } from '../helpers/common';

const downloadApi = `${rootApi}/history-data/download`;

const downloadReportApi = `${rootApi}/s3/download-link`;

const checkDownloadReportObjectApi = `${rootApi}/s3/checkDownloadReportObject`;
const listDownloadReportObjectApi = `${rootApi}/s3/listDownloadReportObject`;
const generateDownloadReportLinkApi = `${rootApi}/s3/generateDownloadReportLink`;

const checkPortfolioDownloadReportObjectApi = `${rootApi}/s3/checkPortfolioDownloadReportObject`;
const listPortfolioDownloadReportObjectApi = `${rootApi}/s3/listPortfolioDownloadReportObject`;
const generatePortfolioDownloadReportLinkApi = `${rootApi}/s3/generatePortfolioDownloadReportLink`;

const checkDownloadDataObjectApi = `${rootApi}/s3/checkDownloadDataObject`;
const listDownloadDataObjectApi = `${rootApi}/s3/listDownloadDataObject`;
const generateDownloadDataLinkApi = `${rootApi}/s3/generateDownloadDataLink`;

const listDownloadConfigObjectApi = `${rootApi}/s3/listDownloadConfigObject`;
const generateDownloadConfigLinkApi = `${rootApi}/s3/generateDownloadConfigLink`;

export const fetchUserDownloadRequests = userId => fetchGet(`${downloadApi}/${userId}`);

export const createDownloadRequest = downloadRequest => fetchPost(downloadApi, downloadRequest);

export const downloadFile = fileName => fetch(`${downloadApi}-file?Authorization=${getToken()}&param=${fileName}`).then(r => r.blob());

export const downloadRequest = downloadRequestId => fetchDelete(`${downloadApi}/${downloadRequestId}`);

export const fetchByIds = ids => fetchPost(`${downloadApi}/by-ids`, ids);

export const downloadTime = stnName => fetchGet(`${rootApi}/stations/stationTime/${stnName}`)

// export const generateDownloadReportLinks = downloadReportRequest => fetchPost(downloadReportApi, downloadReportRequest)

export const checkDownloadReportObject = downloadReportRequest => fetchPost(checkDownloadReportObjectApi, downloadReportRequest)
export const listDownloadReportObject = downloadReportRequest => fetchPost(listDownloadReportObjectApi, downloadReportRequest)
export const generateDownloadReportLink = downloadReportRequest => fetchPost(generateDownloadReportLinkApi, downloadReportRequest)

export const checkPortfolioDownloadReportObject = portfolioDownloadReportRequest => fetchPost(checkPortfolioDownloadReportObjectApi, portfolioDownloadReportRequest)
export const listPortfolioDownloadReportObject = portfolioDownloadReportRequest => fetchPost(listPortfolioDownloadReportObjectApi, portfolioDownloadReportRequest)
export const generatePortfolioDownloadReportLink = portfolioDownloadReportRequest => fetchPost(generatePortfolioDownloadReportLinkApi, portfolioDownloadReportRequest)

export const checkDownloadDataObject = downloadDataRequest => fetchPost(checkDownloadDataObjectApi, downloadDataRequest)
export const listDownloadDataObject = downloadDataRequest => fetchPost(listDownloadDataObjectApi, downloadDataRequest)
export const generateDownloadDataLink = downloadDataRequest => fetchPost(generateDownloadDataLinkApi, downloadDataRequest)

export const listDownloadConfigObject = downloadConfigRequest => fetchPost(listDownloadConfigObjectApi, downloadConfigRequest)
export const generateDownloadConfigLink = downloadConfigRequest => fetchPost(generateDownloadConfigLinkApi, downloadConfigRequest)
